import { List } from 'immutable';
import { investorDocConstants } from '../constants';

export function investorDocs(state = {}, action) {
  switch (action.type) {
    case investorDocConstants.INVESTOR_DOC_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case investorDocConstants.INVESTOR_DOC_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case investorDocConstants.INVESTOR_DOC_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case investorDocConstants.INVESTOR_DOC_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case investorDocConstants.INVESTOR_DOC_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case investorDocConstants.INVESTOR_DOC_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case investorDocConstants.INVESTOR_DOC_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case investorDocConstants.INVESTOR_DOC_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const investorDocIndex = state.items.findIndex(val => val.id == action.response.id);

      if (investorDocIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(investorDocIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case investorDocConstants.INVESTOR_DOC_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case investorDocConstants.INVESTOR_DOC_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case investorDocConstants.INVESTOR_DOC_DELETE_SUCCESS: {
      const { investorDocId } = action;

      if (!state.items) {
        return state;
      }

      const investorDocIndex = state.items.findIndex(val => val.id == investorDocId);

      if (investorDocIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(investorDocIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case investorDocConstants.INVESTOR_DOC_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case investorDocConstants.INVESTOR_DOC_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
